var temp_email = "";
(function() {
  $(document).ready(function() {
    $(document).on("click",".swell-referral-form-list-submit", function(){
      temp_email = $('#swell-referral-refer-emails').val();
    });
    $(document).on("click", ".swell-share-referral-copy", function() {
      setTimeout(function(){
        detachReferralCopy();
        $(".swell-referral-copy-main").prepend("<div class='close-container'></div>");
        $(".swell-referral-copy-main .close-container").html($(".swell-referral-copy-main .swell-referral-back-link").detach());
        $(".swell-referral-copy-link").html($(".swell-referral-copy-link").html().replace("http://",""));
        $(".swell-referral-copy").css("display","flex");
      },20);
    });
    $(document).on("click", ".swell-referral-back-link", function() {
      $(".swell-referral").removeClass("thankyou");
      $(".swell-referral-sidebar-details").show();
    });
    $(document).on("click", ".swell-referral-back-link.checkout", function() {
      $(".post-checkout").hide();
    });
	});
  $(document).on("swell:initialized", function() {
    if($(".campaigns").length>0){
      var added = 0;
      var campaigns = spapi.activeCampaigns;
      for(var t=0;t<campaigns.length;t++){
        if(campaigns[t].id != 458440){
          if(added<3){
            $(".desktop .campaigns-top").append("<li class='swell-campaign'> <div class='swell-campaign-content swell-campaign-link' data-display-mode='modal' data-campaign-id='"+campaigns[t].id+"'> <div class='swell-campaign-icon'> <span class='swell-campaign-icon-content'> <i class='fa "+campaigns[t].icon+"'></i> </span> </div> <div class='swell-campaign-value'> <span class='swell-campaign-value-content'>"+campaigns[t].reward_text+"</span> </div> <div class='swell-campaign-type'> <span class='swell-campaign-type-content'>"+campaigns[t].title+"</span> </div> </div></li>");
          }
          else if(added>=3&&added<7){
            console.log(added);
            $(".desktop .campaigns-middle").append("<li class='swell-campaign'> <div class='swell-campaign-content swell-campaign-link' data-display-mode='modal' data-campaign-id='"+campaigns[t].id+"'> <div class='swell-campaign-icon'> <span class='swell-campaign-icon-content'> <i class='fa "+campaigns[t].icon+"'></i> </span> </div> <div class='swell-campaign-value'> <span class='swell-campaign-value-content'>"+campaigns[t].reward_text+"</span> </div> <div class='swell-campaign-type'> <span class='swell-campaign-type-content'>"+campaigns[t].title+"</span> </div> </div></li>");
          }
          else{
            $(".desktop .campaigns-bottom").append("<li class='swell-campaign'> <div class='swell-campaign-content swell-campaign-link' data-display-mode='modal' data-campaign-id='"+campaigns[t].id+"'> <div class='swell-campaign-icon'> <span class='swell-campaign-icon-content'> <i class='fa "+campaigns[t].icon+"'></i> </span> </div> <div class='swell-campaign-value'> <span class='swell-campaign-value-content'>"+campaigns[t].reward_text+"</span> </div> <div class='swell-campaign-type'> <span class='swell-campaign-type-content'>"+campaigns[t].title+"</span> </div> </div></li>");
          }
          $(".campaigns.mobile").append("<li class='swell-campaign'> <div class='swell-campaign-content swell-campaign-link' data-display-mode='modal' data-campaign-id='"+campaigns[t].id+"'> <div class='swell-campaign-icon'> <span class='swell-campaign-icon-content'> <i class='fa "+campaigns[t].icon+"'></i> </span> </div> <div class='swell-campaign-value'> <span class='swell-campaign-value-content'>"+campaigns[t].reward_text+"</span> </div> <div class='swell-campaign-type'> <span class='swell-campaign-type-content'>"+campaigns[t].title+"</span> </div> </div></li>");
          added++;
        }
      }
      $(".campaigns.mobile").append("<li class='swell-campaign'> <div class='swell-campaign-content refer'> <h2>Refer a Friend</h2><p>Refer a friend and</br>earn $10.</p><a href='/pages/refer'>Start Referring Now</a> </div></li>");
      $(".campaigns.desktop,.campaigns.mobile").addClass("swell-show");
    }
    if($(".swell-discounts-list").length>0){
      var options = spapi.activeRedemptionOptions;
      var count = 0;
      for(var t = 0;t<options.length;t++)
      {
        if(options[t].discount_type == "fixed_amount")
        {
          count++;
          $(".swell-discounts-list").append("<li class='swell-redemption-option'> <div class='swell-redemption-option-content'> <div class='swell-redemption-content'> <div class='swell-redemption-content-holder swell-redemption-link' data-redemption-option-id='"+options[t].id+"'> <div class='swell-redemption-option-value'> "+options[t].name+" </div> <div class='swell-redemption-option-cost'> "+options[t].amount+" Points </div> </div> </div> </li>");
        }
      }
      /*if(count%2==1){
        $(".swell-discounts-list").append("<li class='swell-redemption-option'></li>");
      }*/
    }
  });
  $(document).on("swell:setup", function() {
    if($(".swell-tier-table").length>0){
      SwellConfig.Tier.initializeDummyTier();
      SwellConfig.Tier.initializeCustomTierProperties();
      SwellConfig.Tier.initializeTiers(".swell-tier-table");
      setupSlickSlider();
    }
    if($(".swell-referral").length>0){
      SwellConfig.Referral.initializeReferral(".swell-referral");
      if(spapi.authenticated || (spapi.customer.referral_receipts && spapi.customer.referral_receipts.length > 0)) {
        setupReferrals();
        $(".post-checkout").css("display","flex");
      }
      $(".inner-holder").css("display","flex");
      $(document).on("swell:referral:success", function(jqXHR, textStatus, errorThrown) {
        thankyou();
      });
      $(document).on("swell:referral:error", function(jqXHR, textStatus, errorThrown) {
        if(textStatus && textStatus === "EMAILS_ALREADY_PURCHASED"){
          $(".refer-customer-error").remove();
          $(".swell-referral-sidebar-details").show();
          $(".swell-referral").removeClass("thankyou");
          $(".swell-referral-content-container").addClass("error-message");
          $(".swell-referral-form-body").prepend('<p class="refer-customer-error">Sorry! Looks like this person has already made a purchase. Try referring another friend.</p>');
          $("#swell-referral-refer-emails").addClass("error-border");
        }
        else if(textStatus && textStatus === "Please enter a valid email address"){
          $(".refer-customer-error").remove();
          $(".swell-referral-sidebar-details").show();
          $(".swell-referral").removeClass("thankyou");
          $(".swell-referral-content-container").addClass("error-message");
          $(".swell-referral-form-body").prepend('<p class="refer-customer-error">Please enter valid email addresses seperated with commas</p>');
          $("#swell-referral-refer-emails").addClass("error-border");
        }
      });
      $('body').on('click', '.swell-referral-copy', function(e){
        if($(e.target).hasClass("swell-referral-copy")) {
          e.stopPropagation();
        }
      });
    }
    $(".outter-heading").addClass("active");
    $(".inner-heading").addClass("active");
    $(".outter-text").addClass("active");
    $(".inner-text").addClass("active");
    $(".tier-1-col .vip-sales-item, .tier-1-col .bonus-points-item").removeClass("arrow");
    $(".swell-checkout-balance").html(spapi.customer.adjusted_points_balance);
    // $(".swell-checkout-dollar-balance").html(Math.floor(spapi.customer.adjusted_points_balance/20));
	});
}).call(this);

$(window).resize(function(){
  if($(".swell-tier-table").length>0){
    $('.swell-tier-table .tier-holder').slick('resize');
  }
});

// tiers
(function() {
  window.SwellConfig = window.SwellConfig || {};
  SwellConfig.Tier = {
    getCustomerTierRank: function() {
      var customer_tier, intro_tier, rank, tiers;
      customer_tier = spapi.customer.vip_tier;
      tiers = spapi.activeVipTiers;
      if (customer_tier && customer_tier.id) {
        rank = $.grep(tiers, function(e) {
          return e.id === customer_tier.id;
        })[0].rank;
        return rank;
      } else {
        intro_tier = $.grep(tiers, function(e) {
          return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
        });
        if (intro_tier.length > 0) {
          return intro_tier[0].rank;
        } else {
          return null;
        }
      }
    },
    initializeDummyTier: function() {
      var k, len, tier, tiers;
      tiers = spapi.activeVipTiers;
      for (k = 0, len = tiers.length; k < len; k++) {
        tier = tiers[k];
        tier.rank += 1;
      }
      return tiers.unshift({
        id: 1458,
        rank: 0,
        points: "Free to Join",
        name: "Bronze",
        multiplier: "1x",
        bonus_points: "",
        vip_sales: "",
      });
    },
    initializeCustomTierProperties: function() {
      if(spapi.activeVipTiers.length<=1)
      {
        spapi.activeVipTiers = [
          {
            id: 1458,
            rank: 0,
            points: "Free to Join",
            name: "Bronze",
            multiplier: "1x",
            bonus_points: "",
            vip_sales: ""
          },
          {
            id: 1459,
            rank: 1,
            points: "450 Points",
            name: "Silver",
            multiplier: "1.5x",
            bonus_points: "<i class=\"fa fa-circle-thin\"></i>",
            vip_sales: "<i class=\"fa fa-circle-thin\"></i>"
          },
          {
            id: 1460,
            rank: 2,
            points: "1000 Points",
            name: "Gold",
            multiplier: "2x",
            bonus_points: "<i class=\"fa fa-circle-thin\"></i>",
            vip_sales: "With<span>Early Access</span>"
          }
        ]
      }
      else
      {
        // spapi.activeVipTiers[0].points = "Free to Join",
        // spapi.activeVipTiers[0].multiplier = spapi.activeVipTiers[0].points_multiplier.split(".")[0]+"x",
        // spapi.activeVipTiers[0].bonus_points = "",
        // spapi.activeVipTiers[0].vip_sales = "",

        spapi.activeVipTiers[1].points = "450 Points",
        spapi.activeVipTiers[1].multiplier = spapi.activeVipTiers[1].points_multiplier+"x",
        spapi.activeVipTiers[1].bonus_points = "<i class=\"fa fa-circle-thin\"></i>",
        spapi.activeVipTiers[1].vip_sales = "<i class=\"fa fa-circle-thin\"></i>",

        spapi.activeVipTiers[2].points = "1000 Points",
        spapi.activeVipTiers[2].multiplier = spapi.activeVipTiers[2].points_multiplier.split(".")[0]+"x",
        spapi.activeVipTiers[2].bonus_points = "<i class=\"fa fa-circle-thin\"></i>",
        spapi.activeVipTiers[2].vip_sales = "With<span>Early Access</span>"
      }
    },
    initializeTiers: function(containerSelector) {
      if ($(containerSelector).length === 0) {
        return "";
      }
      tiers = spapi.activeVipTiers;
      customer_tier_rank = SwellConfig.Tier.getCustomerTierRank();
      if(customer_tier_rank == null)
      {
        customer_tier_rank = 0;
      }
      for(var t=0;t<tiers.length;t++)
      {
        if(t==customer_tier_rank)
        {
          tiers[t].current_status="Current Status";
        }
        else
        {
          tiers[t].current_status="";
        }
      }
      $(containerSelector).append("<li class='titles-col'><span class='current-status-item'></span><span class='points-item'></span><span class='benefits-item'>Benefits</span><span class='multiplier-item'>Multiplier</span><span class='bonus-points-item'>Bonus Points</span><span class='vip-sales-item'>VIP Sales</span></li>");
      $(containerSelector).append("<li class='tier-holder'></li>");
      for(var t=0;t<tiers.length;t++)
      {
        console.log(customer_tier_rank);
        if(t==customer_tier_rank && spapi.authenticated)
        {
          $(".tier-holder").append("<div class='tier-"+(t+1)+"-col active'><span class='current-status-item'>"+tiers[t].current_status+"</span><span class='points-item'>"+tiers[t].points+"</span><span class='benefits-item'>"+tiers[t].name+"</span><span class='multiplier-item'>"+tiers[t].multiplier+"</span><span class='bonus-points-item arrow'>"+tiers[t].bonus_points+"</span><span class='vip-sales-item arrow'>"+tiers[t].vip_sales+"</span></div>");
        }
        else
        {
          if(spapi.authenticated)
          {
            $(".tier-holder").append("<div class='tier-"+(t+1)+"-col inactive'><span class='current-status-item'></span><span class='points-item'>"+tiers[t].points+"</span><span class='benefits-item'>"+tiers[t].name+"</span><span class='multiplier-item'>"+tiers[t].multiplier+"</span><span class='bonus-points-item arrow'>"+tiers[t].bonus_points+"</span><span class='vip-sales-item arrow'>"+tiers[t].vip_sales+"</span></div>");
          }
          else
          {
            $(".tier-holder").append("<div class='tier-"+(t+1)+"-col'><span class='current-status-item'></span><span class='points-item'>"+tiers[t].points+"</span><span class='benefits-item'>"+tiers[t].name+"</span><span class='multiplier-item'>"+tiers[t].multiplier+"</span><span class='bonus-points-item arrow'>"+tiers[t].bonus_points+"</span><span class='vip-sales-item arrow'>"+tiers[t].vip_sales+"</span></div>");
          }
        }
      }
    }
  }
}).call(this);

function setupSlickSlider(){
  $('.swell-tier-table .tier-holder').slick({
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: '<i class="fa fa-chevron-right slick-arrow-right"></i>',
    prevArrow: '<i class="fa fa-chevron-left slick-arrow-left"></i>',
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });
}

// referral
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Referral = {
    opts: {
      localization: {
        referralSidebarDetailsAction: "",
        referralSidebarDetailsReward: "",

        referralRegisterHeading: "Give $10, Get $10",
        referralRegisterFormDetails: "Submit your email to get started.",
        referralRegisterFormEmail: "Your Email",
        referralRegisterFormSubmit: "NEXT",
        referralRegisterDetails: "Give your friends $10 off on their first order<br class='mobile'> of $50+ and<br class='desktop'> get $10 in points for each<br class='mobile'> successful referral.",

        referralReferHeading: "Give $10, Get $10",
        referralReferFormEmails: "Your friends' emails (separated by commas)",
        referralReferFormSubmit: "SEND",
        referralReferFormDetails: "Now, enter your friends' email.",
        referralReferFormEmailsDetails: "",
        referralReferDetails: "Give your friends $10 off on their first order<br class='mobile'> of $50+ and<br class='desktop'> get $10 in points for each<br class='mobile'> successful referral.",

        referralReferMediaDetails: "You can also share your link with<br class='mobile'> the buttons below.",

        referralShareFacebook: "Share",
        referralShareCopy: "Copy Link",
        referralShareSMS: "SMS",
        referralShareMessenger: "Message",

        referralFacebookIcon: "swell-icon-facebook1",
        referralLinkIcon: "swell-icon-link",
        referralSMSIcon: "swell-icon-sms",
        referralMessengerIcon: "swell-icon-message",

        referralThanksHeading: "Thanks for Referring!",
        referralThanksDetails: "Remind your friends to check their emails.",

        referralCopyHeading: "Copy Link",
        referralCopyButton: "Copy Link",
        referralCopyDetails: "Copy link and share with your friends."
      },
      templates: {
        referralRegister: '<div class="swell-referral-register"> <h2 class="swell-referral-heading"><%= localization.referralRegisterHeading %></h2> <div class="swell-referral-details-container"><p class="swell-referral-details"><%= localization.referralRegisterDetails %></p></div> <div class="swell-referral-form-wrapper"> <form name="swell-referral-register-form" class="swell-referral-form" id="swell-referral-register-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"><%= localization.referralRegisterFormDetails %></p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="email" name="swell-referral-register-email" id="swell-referral-register-email" required="required" placeholder="<%= localization.referralRegisterFormEmail %>"> </li> <li class="swell-referral-form-list-button"> <div class="swell-referral-form-footer"> <input class="swell-referral-form-list-submit" type="submit" name="swell-referral-register-submit" id="swell-referral-register-submit" value="<%= localization.referralRegisterFormSubmit %>"> </div> </li> </ul> </div> </form> </div> </div>',
        referralRefer: '<div class="swell-referral-refer"> <h2 class="swell-referral-heading"><%= localization.referralReferHeading %></h2> <div class="swell-referral-details-container"><p class="swell-referral-details"><%= localization.referralReferDetails %></p></div> <div class="swell-referral-form-wrapper"> <form class="swell-referral-form" name="swell-referral-refer-form" id="swell-referral-refer-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"><%= localization.referralReferFormDetails %></p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="text" name="swell-referral-refer-emails" id="swell-referral-refer-emails" required="required" placeholder="<%= localization.referralReferFormEmails %>"> <span class="swell-referral-form-field-details"><%= localization.referralReferFormEmailsDetails %></span> </li> <li class="swell-referral-form-list-button"> <input class="swell-referral-form-list-submit" type="submit" name="swell-referral-refer-submit" id="swell-referral-refer-submit" value="<%= localization.referralReferFormSubmit %>"> </li> </ul> </div> </form> </div> <div class="swell-referral-media-wrapper"> <p class="swell-referral-media-details"><%= localization.referralReferMediaDetails %></p> <ul class="swell-referral-media-list"> <li class="swell-referral-medium swell-share-referral-facebook"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralFacebookIcon %>" aria-hidden="true"></i>&nbsp;<%= localization.referralShareFacebook %> </div> </li> <li class="swell-referral-medium swell-share-referral-sms"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon swell-icon-sms" aria-hidden="true"></i>&nbsp;SMS </div> </li> <li class="swell-referral-medium swell-share-referral-messenger"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralMessengerIcon %>" aria-hidden="true"></i>&nbsp;<%= localization.referralShareMessenger %> </div> </li> <li class="swell-referral-medium swell-share-referral-copy"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralLinkIcon %>" aria-hidden="true"></i>&nbsp;<%= localization.referralShareCopy %> </div> </li> </ul> </div> </div>'
      }
    },
    initializeReferral: function(containerSelector) {
      var email = $(containerSelector).data("customer-email");
      if (email) {
        spapi.storage.setItem("referrer_email", email);
        spapi.customer.email = email;
      }
      Swell.Referral.initializeReferral(".swell-referral", SwellConfig.Referral.opts);
      $(".boku-post-checkout").css("display","flex");
      $(".swell-referral").show();
    }
  };
}).call(this);

function setupReferrals (){
  $(".swell-referral-content").show();
  $(".border").show();
  if(spapi.customer.referral_receipts.length > 0) {
    $(".referral-table").show();

    referrals = spapi.customer.referral_receipts;

    referrals.forEach(function(referral) {
      status = null;

      if(referral.completed_at){ 
        status = "Purchased ($10 earned)";
      } else {
        status = "Invited";
      }

      $(".swell-referral-table tbody").append('<tr> <td> <div class="trucate-email">' +  referral.email + '</div></td><td>' + status +'</td></tr>');
    });  
  }
}

function detachReferralCopy(){
  if($(".swell-referral-copy").length > 0)
  {
    $("body").append($(".swell-referral-copy").detach());
  }
}

function thankyou(){
  $(".swell-referral-sidebar-details").hide();
  $(".swell-referral").addClass("thankyou");
  if($(".swell-referral-table").length>0)
  {
    $(".swell-referral-table tbody").append("<tr><td>"+temp_email+"</td><td>Invited</td></tr>");
  }
}
